"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _scenicSpot = _interopRequireDefault(require("@/mixins/scenic-spot"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InvoiceDialog',
  mixins: [_scenicSpot.default],
  //此js存放商品的部分函数方法
  data: function data() {
    return {
      form: {
        id: null,
        invoiceNumber: '',
        customerName: '',
        date: '',
        type: '',
        status: '',
        totalAmount: 0,
        titleType: '',
        fileUrl: '',
        titleName: '',
        payPrice: '',
        items: [{
          name: '',
          description: '',
          quantity: 1,
          unitPrice: 0,
          amount: 0
        }],
        remarks: '',
        attachments: []
      },
      isView: false,
      title: '',
      invoiceDialogVisible: false,
      rules: {
        orderNo: [{
          required: true,
          message: '请输入订单编号',
          trigger: 'blur'
        }],
        titleName: [{
          required: true,
          message: '请输入客户名称',
          trigger: 'blur'
        }],
        titleType: [{
          required: true,
          message: '请选择发票类型',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: '请选择发票状态',
          trigger: 'change'
        }],
        payPrice: [{
          required: true,
          message: '请输入发票金额',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    // 显示编辑/查看弹窗
    showEdit: function showEdit() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var isView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.invoiceDialogVisible = true;
      this.isView = isView;
      if (row) {
        // 编辑或查看模式
        this.form = JSON.parse(JSON.stringify(row));
        this.form.status = this.getStatusText(this.form.status);
        if (isView) {
          this.title = '发票详情';
        } else {
          this.title = '编辑发票';
        }
      } else {
        // 新增模式
        this.title = '新增发票';
        this.resetForm();
      }
    },
    // 重置表单
    resetForm: function resetForm() {
      this.form = {
        id: null,
        invoiceNumber: '',
        customerName: '',
        date: '',
        type: 'special',
        status: '0',
        totalAmount: 0,
        items: [{
          name: '',
          description: '',
          quantity: 1,
          unitPrice: 0,
          amount: 0
        }],
        remarks: '',
        attachments: []
      };
    },
    // 添加发票项目
    addItem: function addItem() {
      this.form.items.push({
        name: '',
        description: '',
        quantity: 1,
        unitPrice: 0,
        amount: 0
      });
    },
    // 删除发票项目
    removeItem: function removeItem(index) {
      this.form.items.splice(index, 1);
      this.calculateTotalAmount();
    },
    // 计算单个项目金额
    calculateItemAmount: function calculateItemAmount(item) {
      item.amount = item.quantity * parseFloat(item.unitPrice || 0);
      this.calculateTotalAmount();
    },
    // 计算发票总金额
    calculateTotalAmount: function calculateTotalAmount() {
      this.form.totalAmount = this.form.items.reduce(function (total, item) {
        return total + item.amount;
      }, 0);
    },
    // 状态文本
    getStatusText: function getStatusText(status) {
      var statusMap = {
        0: '待开票',
        1: '已开票',
        2: '已拒绝',
        3: '已作废'
      };
      return statusMap[status] || status;
    },
    // 删除附件
    removeAttachment: function removeAttachment(index) {
      this.form.attachments.splice(index, 1);
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.formValidate.validate(function (valid) {
        if (valid) {
          // 表单验证通过，提交数据
          _this2.$message.success(_this2.form.id ? '发票更新成功' : '发票创建成功');
          _this2.invoiceDialogVisible = false;

          // 触发成功事件，通知父组件刷新数据
          _this2.$emit('success', _this2.form);
          console.log('这里是否触发', _this2.form);
        } else {
          _this2.$message.warning('请填写完整的发票信息');
        }
      });
    },
    //点击头像
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (tit === '1' && !num) {
          _this.form.fileUrl = img[0].sattDir;
        }
      }, tit, 'store');
    }
  }
};